import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Utils } from './utils/utils';
import { Constants } from '../model/constants';
import { RestorePasswordModel } from '../model/restorepasswordmodel';

@Injectable({
  providedIn: 'root'
})
export class RestorePasswordService {

    constructor(private http: HttpClient) { }

    code(request: RestorePasswordModel): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'restorepwd/code';
        return this.http.post(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            JSON.stringify(request),
            {headers}
        );
    }

    check(request: RestorePasswordModel): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'restorepwd/check';
        return this.http.post(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            JSON.stringify(request),
            {headers}
        );
    }

    pwd(request: RestorePasswordModel): Observable<any> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');
        const url = 'restorepwd/pwd';
        return this.http.post(
            Utils.setHost(Constants.REST_ENDPOINT, url),
            JSON.stringify(request),
            {headers}
        );
    }

}
